import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from 'utils'

export const blockIp = createAsyncThunk(
    'ipAccess/blockIp',
    async ({ payload }) => {
        try {
            const res = await axios({
                method: 'POST',
                url: getConfig.API_URL + 'block_ip',
                data: payload,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: SessionManager.getCookie('user_token'),
                },
            })
            return res
        } catch (error) {
            return error.response
        }
    },
)

export const updateBlockIp = createAsyncThunk(
    'ipAccess/updateBlockIp',
    async ({ payload }) => {
        try {
            const res = await axios({
                method: 'PUT',
                url: getConfig.API_URL + 'block_ip',
                data: payload,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: SessionManager.getCookie('user_token'),
                },
            })
            return res
        } catch (error) {
            return error.response
        }
    },
)

export const blockedIpList = createAsyncThunk(
    'ipAccess/blockedList',
    async () => {
        try {
            const res = await axios({
                method: 'GET',
                url: getConfig.API_URL + 'block_ip',
                params: { status: 'Block' },
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: SessionManager.getCookie('user_token'),
                },
            })
            return res
        } catch (error) {
            return error.response
        }
    },
)

export const ipAccessOverview = createAsyncThunk(
    'ipAccess/overview',
    async ({ navigate }) => {
        try {
            const res = await axios({
                method: 'GET',
                url: getConfig.API_URL + 'ip_access',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: SessionManager.getCookie('user_token'),
                },
            })
            return res
        } catch (error) {
            return error.response
        }
    },
)

const ipAccessSlice = createSlice({
    name: 'ipAccess',
    initialState: {
        premises: [],
        countData: null,
        sessionDays: 30,
        loading: false,
        blocked: [],
        blockedLoading: false,
    },
    reducers: {
        clearIpAccess: (state) => {
            state.premises = []
            state.countData = null
            state.sessionDays = 30
            state.blocked = []
        },
    },
    extraReducers: (builder) => {
        builder.addCase(blockIp.fulfilled, (state, action) => {
            const payload = action.payload
            if (payload?.status === 401) {
                showTokenExpiredAlert(payload?.data?.message, action.meta.arg.navigate)
            } else if (payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            }
        })
        builder.addCase(updateBlockIp.fulfilled, (state, action) => {
            const payload = action.payload
            if (payload?.status === 401) {
                showTokenExpiredAlert(payload?.data?.message, action.meta.arg.navigate)
            } else if (payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            }
        })
        builder.addCase(blockedIpList.pending, (state) => {
            state.blockedLoading = true
        })
        builder.addCase(blockedIpList.fulfilled, (state, action) => {
            state.blockedLoading = false
            const payload = action.payload

            if (payload?.status === 401) {
                showTokenExpiredAlert(payload?.data?.message, action.meta.arg.navigate)
                state.blocked = []
                return
            }
            if (payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
                state.blocked = []
                return
            }

            if (payload?.status === 200) {
                const body = payload.data
                state.blocked = Array.isArray(body?.data) ? body.data : []
            } else {
                state.blocked = []
            }
        })
        builder.addCase(blockedIpList.rejected, (state) => {
            state.blockedLoading = false
            state.blocked = []
        })
        builder.addCase(ipAccessOverview.pending, (state) => {
            state.loading = true
        })
        builder.addCase(ipAccessOverview.fulfilled, (state, action) => {
            state.loading = false
            const payload = action.payload

            if (payload?.status === 401) {
                showTokenExpiredAlert(payload?.data?.message, action.meta.arg.navigate)
                state.premises = []
                state.countData = null
                return
            }
            if (payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
                state.premises = []
                state.countData = null
                return
            }

            if (payload?.status === 200) {
                const body = payload.data
                state.premises = Array.isArray(body?.data) ? body.data : []
                state.countData = body?.countData ?? null
                state.sessionDays = body?.sessionDays ?? 30
            } else {
                state.premises = []
                state.countData = null
            }
        })
        builder.addCase(ipAccessOverview.rejected, (state) => {
            state.loading = false
            state.premises = []
            state.countData = null
        })
    },
})

export const { clearIpAccess } = ipAccessSlice.actions
export default ipAccessSlice.reducer
